/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_EntertainmentInputs */



/**
* | output |
* | --- |
* | "Entertainment" |
*
* @param {Subtitle_Export_Keyword_EntertainmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_entertainment = /** @type {((inputs?: Subtitle_Export_Keyword_EntertainmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_EntertainmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Divertissement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterhaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Divertimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Развлечение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entretenimiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("娱乐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エンターテインメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मनोरंजन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entretenimento")
	return /** @type {LocalizedString} */ ("Entertainment")
});